// extracted by mini-css-extract-plugin
export default {"short_title":"TextileFairs_short_title__7fl3h","main_title":"TextileFairs_main_title__5InGu"};